import { createApp } from 'vue'
import App from './App.vue'
import WaveUI from 'wave-ui'
import 'wave-ui/dist/wave-ui.css'
import router from './router'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons'
import { faTelegram, faGoogle, faMicrosoft } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faSignOutAlt);
library.add(faTelegram);
library.add(faGoogle);
library.add(faMicrosoft);


const app = createApp(App).use(router).component('font-awesome-icon', FontAwesomeIcon);

new WaveUI(app, {});

app.mount('#app')
